<template>
  <div :class="padding" v-if="hasImages">
    <div v-if="renderMinimalistSlider">
      <v-carousel height="120" :cycle="false" hide-delimiters hide-controls>
        <v-carousel-item>
          <v-layout row wrap>
            <v-flex v-for="(image, i) in images" :key="image.asset.id" px-1 :class="layoutItems">
              <v-img :src="image.asset.url" class="image" min-height="120" contain @click="showCarousel(i)"></v-img>
            </v-flex>
          </v-layout>
        </v-carousel-item>
      </v-carousel>
    </div>
    <div v-else>
      <v-carousel height="120" :cycle="false" hide-delimiters>
        <v-carousel-item v-for="i in images.length" :key="i" :transition="false" :reverse-transition="false">
          <v-layout row wrap>
            <v-flex v-for="j in imagesPerCarouselItem" :key="j" px-1 :class="layoutItems">
              <v-img :src="getSrc(i, j)" class="image" min-height="120" contain @click="showCarousel(getItemIndex(i, j))"></v-img>
            </v-flex>
          </v-layout>
        </v-carousel-item>
      </v-carousel>
    </div>
    <Carousel ref="carousel" :attachments="images"></Carousel>
  </div>
</template>

<script>
import Carousel from '../../../common/ui/Carousel.vue'
import Constants from '../../../common/constants'

const LAYOUT = {
  'xs1': { 'imagesPerCarouselItem': 1, 'layoutItems': 'xs12' },
  'xs2': { 'imagesPerCarouselItem': 2, 'layoutItems': 'xs6' },
  'xs3': { 'imagesPerCarouselItem': 2, 'layoutItems': 'xs6' },
  'xs4': { 'imagesPerCarouselItem': 2, 'layoutItems': 'xs6' },
  'xs5': { 'imagesPerCarouselItem': 3, 'layoutItems': 'xs4' },
  'xs6': { 'imagesPerCarouselItem': 4, 'layoutItems': 'xs3' },
  'xs7': { 'imagesPerCarouselItem': 4, 'layoutItems': 'xs3' },
  'xs8': { 'imagesPerCarouselItem': 4, 'layoutItems': 'xs3' },
  'xs9': { 'imagesPerCarouselItem': 4, 'layoutItems': 'xs3' },
  'xs10': { 'imagesPerCarouselItem': 6, 'layoutItems': 'xs2' },
  'xs11': { 'imagesPerCarouselItem': 6, 'layoutItems': 'xs2' },
  'xs12': { 'imagesPerCarouselItem': 6, 'layoutItems': 'xs2' }
}

export default {
  props: {
    attachments: Array,
    layout: {
      type: String,
      default: 'xs6'
    },
    padding: String
  },

  components: {
    Carousel
  },

  computed: {
    hasImages () {
      return this.images.length
    },
    renderMinimalistSlider () {
      return this.images.length <= this.imagesPerCarouselItem
    },
    images () {
      return this.attachments.filter(item => this.isImage(item.asset.name))
    },
    imagesPerCarouselItem () {
      return LAYOUT[this.layout].imagesPerCarouselItem
    },
    layoutItems () {
      return LAYOUT[this.layout].layoutItems
    }
  },

  methods: {
    isImage (fileName) {
      return fileName.toLowerCase().match(Constants.ALLOWED_IMAGE_EXTENSIONS) != null
    },
    getSrc (i, j) {
      let index = this.getItemIndex(i, j)
      return this.images[index].asset.url
    },
    getItemIndex (i, j) {
      let index = (i - 1) + (j - 1)
      let length = this.images.length
      return (index >= length) ? (index - length) : index
    },
    showCarousel (index) {
      this.$refs.carousel.showDialogIndex(index)
    }
  }
}
</script>

<style scoped>
.v-carousel {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.image:hover {
  cursor: pointer;
}
</style>
